import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

const SrCalendarTimeRow = ({
  hour,
  minute,
  onClick,
  selected,
  disabled,
  isSmartApartment,
}) => {
  const date = moment()
    .hour(hour)
    .minute(minute);

  return (
    <span
      className={classnames('row', {
        active: selected,
        disabled: disabled,
      })}
      onClick={() => {
        if (disabled) {
          return;
        }

        onClick(`${hour}:${minute}`);
      }}
    >
      <span>{date.format('LT')}</span>
      {disabled && (
        <span>{isSmartApartment ? 'Apartment closed' : 'Not available'}</span>
      )}
    </span>
  );
};

SrCalendarTimeRow.propTypes = {
  hour: PropTypes.number.isRequired,
  minute: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  isSmartApartment: PropTypes.bool,
};

SrCalendarTimeRow.defaultProps = {
  isSmartApartment: false,
};

SrCalendarTimeRow.displayName = 'SrCalendarTimeRow';

export default SrCalendarTimeRow;
